/**
 * Copyright (c) 2018-present, Didi, Inc.
 * All rights reserved.
 *
 * @author Cory(kuanghongrui@didichuxing.com)
 *
 * @file The class of OMGH5CustomPlugin
 */

import { ITrackerContext } from 'com/didichuxing/tracker/context/ITrackerContext';
import { IEventReportor } from 'com/didichuxing/tracker/plugin/reportor/IEventReportor';
import AOMGH5CustomPlugin from 'com/didichuxing/tracker/h5/plugins/AOMGH5CustomPlugin';
import SendStrategyChoice from 'com/didichuxing/tracker/h5/plugins/utils/SendStrategyChoice';
import { ITrackedEvent } from 'com/didichuxing/tracker/event/ITrackedEvent';

export default class OMGH5CustomPlugin extends AOMGH5CustomPlugin {

    /**
     * @override
     * @inheritDoc
     * @returns {IEventReportor}
     */
    protected getEventReportor(event: ITrackedEvent): IEventReportor {
        return SendStrategyChoice.switchSendStrategy(this.getContext() as ITrackerContext, event);
    }
}
